import {Bank} from "./bank";
import {ActionTrigger} from "./actionTrigger";
import {MailReceiverType} from "./mailReceiverType";

/**
 * .
 * Created by jlado on 13/9/16.
 */
export class MailTemplate {

    id: string;
    action: ActionTrigger = new ActionTrigger(null);
    copyTo: string;
    receivers: MailReceiverType[] = [];
    description: string;
    periodicity: number;
    templateBody: string;
    templateSubject: string;
    bank: Bank = new Bank(null);

    constructor(other ?: MailTemplate) {
        if (other) {
            this.id = other.id;
            this.action = new ActionTrigger(other.action);
            this.copyTo = other.copyTo;
            this.receivers = other.receivers.map((receiverType) => new MailReceiverType(receiverType));
            this.description = other.description;
            this.periodicity = other.periodicity;
            this.templateBody = other.templateBody;
            this.templateSubject = other.templateSubject;
            this.bank = new Bank(other.bank);
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/domain/mailTemplate.ts
 **/